import _ from 'lodash';

export const computePricing = (msrp, incentives) => {
  const getLuxuryTaxVal = netPrice =>
    msrp.flt && msrp.flt.above < netPrice
      ? (netPrice - msrp.flt.above) * msrp.flt.taxRate
      : 0;

  const totalMsrp = msrp.employeePrice ? msrp.employeePrice : msrp.totalMsrp;
  const eventDiscount = msrp.isConfidencePrice
    ? totalMsrp - msrp.supplierPrice
    : 0;
  const incentiveDiscount = incentives.total
    ? incentives.total
    : incentives.value;
  const totalDiscountWithoutPacakge = incentiveDiscount + eventDiscount;
  const netPrice = msrp.totalMsrp - totalDiscountWithoutPacakge;
  const employeePriceDifference = msrp.employeePrice
    ? msrp.totalMsrp - msrp.employeePrice
    : 0;
  const totalDiscount = totalDiscountWithoutPacakge + msrp.opdTotal;
  const totalEmployeeDiscount = employeePriceDifference
    ? totalDiscount + employeePriceDifference
    : 0;
  const netEmployeePrice = totalMsrp - totalDiscountWithoutPacakge;

  const luxuryTaxNetPrice = netPrice + getLuxuryTaxVal(netPrice);
  const luxuryTaxNetEmployeePrice =
    netEmployeePrice + getLuxuryTaxVal(netEmployeePrice);

  return _.assign({}, msrp, {
    incentives: incentives,
    isSeeDealer: !msrp.isActualPrice,
    eventDiscount: eventDiscount,
    totalDiscount: totalDiscount,
    netPrice: luxuryTaxNetPrice,
    netEmployeePrice: luxuryTaxNetEmployeePrice,
    employeePriceDifference: employeePriceDifference,
    totalEmployeeDiscount: totalEmployeeDiscount,
    luxuryTax: {
      val: getLuxuryTaxVal(netPrice),
      employeeVal: getLuxuryTaxVal(netEmployeePrice),
      label: msrp.flt && msrp.flt.label
    }
  });
};
